export default {"src":"/customer-services/_next/static/media/tv.424f5e11.svg","height":31,"width":36,"blurWidth":0,"blurHeight":0};